global.self = global; // whatwg-fetch polyfill relies on this

require('isomorphic-fetch');
require('abortcontroller-polyfill/dist/polyfill-patch-fetch');
require('dialog-polyfill-universal');
